import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CampaignDriveFilterService {
  madMonthYear: any = {};

  constructor() {}

  toggleProductDevOwner(
    username: string,
    campaignSearchParams: any,
    productDevManagers: any[]
  ): { campaignSearchParams: any; allProductDevManagerSelected: boolean } {
    if (!campaignSearchParams) campaignSearchParams = {};
    if (!campaignSearchParams.projectLeaders) campaignSearchParams.projectLeaders = [];

    const userExists = campaignSearchParams.projectLeaders.includes(username);

    if (userExists) {
      campaignSearchParams.projectLeaders = campaignSearchParams.projectLeaders.filter((u: any) => u !== username);
    } else {
      campaignSearchParams.projectLeaders.push(username);
    }

    const allProductDevManagerSelected = productDevManagers.length === campaignSearchParams.projectLeaders.length;

    return { campaignSearchParams, allProductDevManagerSelected };
  }

  toggleCnCManager(
    username: string,
    campaignSearchParams: any,
    cncManagers: any[]
  ): { campaignSearchParams: any; allCnCManagerSelected: boolean } {
    if (!campaignSearchParams) campaignSearchParams = {};
    if (!campaignSearchParams.cncManagers) campaignSearchParams.cncManagers = [];

    const userExists = campaignSearchParams.cncManagers.includes(username);

    if (userExists) {
      campaignSearchParams.cncManagers = campaignSearchParams.cncManagers.filter((u: any) => u !== username);
    } else {
      campaignSearchParams.cncManagers.push(username);
    }

    const allCnCManagerSelected = cncManagers.length === campaignSearchParams.cncManagers.length;

    return { campaignSearchParams, allCnCManagerSelected };
  }

  toggleActiveProduct(value: string, campaignSearchParams: any): any {
    if (!campaignSearchParams) campaignSearchParams = {};
    if (!campaignSearchParams.activeProduct) campaignSearchParams.activeProduct = [];

    const exists = campaignSearchParams.activeProduct.includes(value);

    if (exists) {
      campaignSearchParams.activeProduct = campaignSearchParams.activeProduct.filter((u: any) => u !== value);
    } else {
      campaignSearchParams.activeProduct.push(value);
    }

    return campaignSearchParams;
  }

  selectAllProductDevManager(
    e: any,
    allProductDevManagerSelected: boolean,
    campaignSearchParams: any,
    productDevManagers: any[]
  ): { allProductDevManagerSelected: boolean; campaignSearchParams: any } {
    e.preventDefault();
    allProductDevManagerSelected = !allProductDevManagerSelected;

    if (!campaignSearchParams) campaignSearchParams = {};
    if (!campaignSearchParams.projectLeaders) campaignSearchParams.projectLeaders = [];

    if (allProductDevManagerSelected) {
      campaignSearchParams.projectLeaders = productDevManagers.map((u) => u.username);
    } else {
      campaignSearchParams.projectLeaders = [];
    }

    return { allProductDevManagerSelected, campaignSearchParams };
  }

  selectAllMad(
    e: any,
    allMadSelected: boolean,
    campaignSearchParams: any,
    years: number[],
    months: string[],
    madMonthYear: any,
    yearSelected: number[]
  ): { allMadSelected: boolean; campaignSearchParams: any; madMonthYear: any; yearSelected: number[] } {
    e.preventDefault();
    allMadSelected = !allMadSelected;

    if (!campaignSearchParams) {
      campaignSearchParams = {};
    }
    if (!campaignSearchParams.selectedMonths) {
      campaignSearchParams.selectedMonths = [];
    }

    if (allMadSelected) {
      yearSelected = years.map((y) => y);

      years.forEach((y) => {
        months.forEach((m) => (madMonthYear[y][m] = true));
      });
    } else {
      yearSelected = [];

      years.forEach((y) => {
        months.forEach((m) => (madMonthYear[y][m] = false));
      });
    }

    campaignSearchParams.selectedMonths = [].concat(...yearSelected.map((y) => months.map((m) => y + m)));

    return { allMadSelected, campaignSearchParams, madMonthYear, yearSelected };
  }

  selectAllCnCManager(
    e: any,
    allCnCManagerSelected: boolean,
    campaignSearchParams: any,
    cncManagers: any[]
  ): { allCnCManagerSelected: boolean; campaignSearchParams: any } {
    e.preventDefault();

    allCnCManagerSelected = !allCnCManagerSelected;

    if (!campaignSearchParams) {
      campaignSearchParams = {};
    }
    if (!campaignSearchParams.cncManagers) {
      campaignSearchParams.cncManagers = [];
    }

    if (allCnCManagerSelected) {
      campaignSearchParams.cncManagers = cncManagers.map((u) => u.username);
    } else {
      campaignSearchParams.cncManagers = [];
    }

    return { allCnCManagerSelected, campaignSearchParams };
  }

  generateMadLabel(years: number[], months: string[], translatePipe: any): string {
    let label = '';

    years.forEach((year) => {
      const selectedMonths = months.filter((month) => this.madMonthYear[year][month]).length;

      if (selectedMonths === months.length) {
        label += `${year}, `;
      } else {
        months.forEach((month) => {
          if (this.madMonthYear[year][month]) {
            const monthKey = `THREE_LETTER_MONTH_PREFIX${month}`;
            label += `${translatePipe.transform(monthKey)}-${year}, `;
          }
        });
      }
    });

    return label.trim().replace(/,\s*$/, '');
  }

  selectYear(
    e: any,
    year: number,
    months: string[],
    campaignSearchParams: any,
    madMonthYear: any,
    yearSelected: number[]
  ): { campaignSearchParams: any; madMonthYear: any; yearSelected: number[] } {
    e.preventDefault();

    if (yearSelected.indexOf(year) < 0) {
      yearSelected.push(year);
      months.forEach((m) => (madMonthYear[year][m] = true));
    } else {
      yearSelected = yearSelected.filter((y) => y !== year);
      months.forEach((m) => (madMonthYear[year][m] = false));
    }

    if (!campaignSearchParams) {
      campaignSearchParams = {};
    }
    if (!campaignSearchParams.selectedMonths) {
      campaignSearchParams.selectedMonths = [];
    }

    campaignSearchParams.selectedMonths = [].concat(...yearSelected.map((y) => months.map((m) => y + m)));

    return { campaignSearchParams, madMonthYear, yearSelected };
  }

  monthSelected(
    e: any,
    year: number,
    month: string,
    months: string[],
    campaignSearchParams: any,
    madMonthYear: any,
    yearSelected: number[]
  ): { campaignSearchParams: any; madMonthYear: any; yearSelected: number[] } {
    if (e) e.preventDefault();

    if (!campaignSearchParams) {
      campaignSearchParams = {};
    }
    if (!campaignSearchParams.selectedMonths) {
      campaignSearchParams.selectedMonths = [];
    }

    const isSelected = campaignSearchParams.selectedMonths.find((u: any) => u === `${year}${month}`);

    if (isSelected) {
      madMonthYear[year][month] = false;
      campaignSearchParams.selectedMonths = campaignSearchParams.selectedMonths.filter(
        (u: any) => u !== `${year}${month}`
      );

      const idx = yearSelected.indexOf(year);
      if (idx > -1) {
        yearSelected.splice(idx, 1);
      }
    } else {
      madMonthYear[year][month] = true;
      campaignSearchParams.selectedMonths.push(`${year}${month}`);

      const allMonthsSelected = months.every((m) => madMonthYear[year][m]);
      const idx = yearSelected.indexOf(year);

      if (allMonthsSelected && idx === -1) {
        yearSelected.push(year);
      }
    }

    return { campaignSearchParams, madMonthYear, yearSelected };
  }
}
